const NewTemplate = (props) => {
	return <div>New Template</div>;
};

export default NewTemplate;
